export default __webpack_public_path__ + "static/media/people.d565ef93.svg";